/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_EnableInputs */

const en_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Foot Pedal Control`)
};

const fr_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer le contrôle par pédale`)
};

const de_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fußpedalsteuerung aktivieren`)
};

const it_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita il controllo del pedale`)
};

const ru_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить управление с помощью ножной педали`)
};

const es_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar el control del pedal`)
};

const zh_cn2_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用脚踏板控制`)
};

const ja_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フットペダルコントロールを有効にする`)
};

const hi_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ुट पेडल नियंत्रण सक्षम करें`)
};

const pt_pt2_options_pedal_enable = /** @type {(inputs: Options_Pedal_EnableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar o controle por pedal`)
};

/**
* | output |
* | --- |
* | "Enable Foot Pedal Control" |
*
* @param {Options_Pedal_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_enable = /** @type {((inputs?: Options_Pedal_EnableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_EnableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_enable(inputs)
	if (locale === "de") return de_options_pedal_enable(inputs)
	if (locale === "it") return it_options_pedal_enable(inputs)
	if (locale === "ru") return ru_options_pedal_enable(inputs)
	if (locale === "es") return es_options_pedal_enable(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_enable(inputs)
	if (locale === "ja") return ja_options_pedal_enable(inputs)
	if (locale === "hi") return hi_options_pedal_enable(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_enable(inputs)
	return en_options_pedal_enable(inputs)
});